import { Box, Card, FormControl, InputLabel, MenuItem, Pagination, Select, SelectChangeEvent, Typography } from '@mui/material';
import ListItems from './ListItems.tsx';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { PAGE_SIZE } from '../../constants/numbers.ts';
import { IPackage } from '../../interfaces/studio.ts';

type filterType = {
	category?: string;
	medias?: string;
	contentTypes?: string;
	quality?: string;
};

export default function List() {
	const { t } = useTranslation();

	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(0);
	const [packages, setPackages] = useState<IPackage[] | null[]>([null, null, null]);
	const [filtersOption, setFiltersOption] = useState<any>({
		categories: [],
		medias: [],
		content_types: [],
		qualities: [],
	});
	const [filters, setFilters] = useState<filterType>({
		category: undefined,
		medias: undefined,
		contentTypes: undefined,
		quality: undefined,
	});

	useEffect(() => {
		axios({
			method: 'get',
			url: `studio/packageDropdowns`,
		}).then(r => {
			if (r?.data?.success) {
				setFiltersOption(r?.data?.data);
			}
		});
	}, []);

	const getPackages = () => {
		axios({
			method: 'get',
			url: `/studio/packages`,
			params: {
				page: page,
				limit: PAGE_SIZE,
				category: filters?.category !== undefined ? filtersOption.categories[+filters?.category]?.id : undefined,
				media: filters?.medias !== undefined ? filtersOption.medias[+filters?.medias]?.id + '' : undefined,
				content_type: filters?.contentTypes !== undefined ? filtersOption.content_types[+filters?.contentTypes]?.id : undefined,
				quality: filters?.quality !== undefined ? filtersOption.qualities[+filters?.quality]?.id : undefined,
			},
		}).then(r => {
			if (r?.data?.success) {
				setPackages(r?.data?.data);
				setTotal(r?.data?.pagination?.total);
			}
		});
	};

	useEffect(() => {
		getPackages();
	}, [page]);

	useEffect(() => {
		if (page === 1) {
			getPackages();
		} else {
			setPage(1);
			setPackages([]);
		}
	}, [filters]);

	const handleFiltersCategory = (e: SelectChangeEvent) => {
		setFilters(p => ({ ...p, category: e.target.value }));
	};
	const handleFiltersMedias = (e: SelectChangeEvent) => {
		setFilters(p => ({ ...p, medias: e.target.value }));
	};
	const handleFiltersContentTypes = (e: SelectChangeEvent) => {
		setFilters(p => ({ ...p, contentTypes: e.target.value }));
	};
	const handleFiltersQualities = (e: SelectChangeEvent) => {
		setFilters(p => ({ ...p, quality: e.target.value }));
	};

	const changePage = (_: React.ChangeEvent<unknown>, newPage: number) => {
		setPage(newPage);
	};
	return (
		<Box className={'flex w-full flex-col gap-6'}>
			<Card>
				<Box className={'flex flex-col flex-wrap justify-between gap-4 px-6 py-4 md:flex-row'}>
					<FormControl className="grow basis-0">
						<InputLabel>{t('category')}</InputLabel>
						<Select value={filters?.category} label={t('category')} onChange={handleFiltersCategory}>
							<MenuItem value={undefined} key={filtersOption?.categories.length}>
								{t('none')}
							</MenuItem>
							{filtersOption?.categories?.map((c: any, index: number) => (
								<MenuItem value={index} key={index}>
									{c.title}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl className="grow basis-0">
						<InputLabel>{t('release-platform')}</InputLabel>
						<Select value={filters?.medias} label={t('release-platform')} onChange={handleFiltersMedias}>
							<MenuItem value={undefined} key={filtersOption?.categories.length}>
								{t('none')}
							</MenuItem>
							{filtersOption?.medias?.map((c: any, index: number) => (
								<MenuItem value={index} key={index}>
									{c.title}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl className="grow basis-0">
						<InputLabel>{t('content_type')}</InputLabel>
						<Select value={filters?.contentTypes} label={t('content-type')} onChange={handleFiltersContentTypes}>
							<MenuItem value={undefined} key={filtersOption?.categories.length}>
								{t('none')}
							</MenuItem>
							{filtersOption?.content_types?.map((c: any, index: number) => (
								<MenuItem value={index} key={index}>
									{c.title}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl className="grow basis-0">
						<InputLabel>{t('quality')}</InputLabel>
						<Select value={filters?.quality} label={t('quality')} onChange={handleFiltersQualities}>
							<MenuItem value={undefined} key={filtersOption?.categories.length}>
								{t('none')}
							</MenuItem>
							{filtersOption?.qualities?.map((c: any, index: number) => (
								<MenuItem value={index} key={index}>
									{c.title}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
			</Card>

			<Card>
				{packages.length > 0 ? (
					<Box className="flex w-full flex-wrap gap-3.5 p-6">{packages?.map(p => <ListItems data={p} />)}</Box>
				) : (
					<Box className={'flex h-48 items-center justify-center'}>
						<Typography>{t('no_content_found')}</Typography>
					</Box>
				)}
			</Card>

			{Math.ceil(total / PAGE_SIZE) > 1 && <Pagination count={Math.ceil(total / PAGE_SIZE)} page={page} onChange={changePage} variant="outlined" shape="rounded" className={'m-auto mb-9 flex justify-center'} color={'primary'} />}
		</Box>
	);
}
